export const ZOOM_MEETING_URL =
  'https://us02web.zoom.us/j/9172047844?pwd=amIyWEkxYUxYYU5ERTNDRUVHaHc4Zz09';

const isHttpUrl = (value) => typeof value === 'string' && /^https?:\/\//i.test(value.trim());

export const isZoomEnrollment = (enrollment) =>
  enrollment?.session_location_type === 'zoom' || enrollment?.class_location_type === 'zoom';

export const resolveZoomMeetingUrl = (enrollment) => {
  if (isHttpUrl(enrollment?.session_location_details)) {
    return enrollment.session_location_details.trim();
  }
  if (isHttpUrl(enrollment?.location_details)) {
    return enrollment.location_details.trim();
  }
  return ZOOM_MEETING_URL;
};
